import type { MarkdownDensity } from './presentation';
import type { MarkdownTypographyTokens } from '../markdown/primitives';

const SHARED_INLINE_TEXT = 'break-words hyphens-auto [overflow-wrap:anywhere]';

const MARKDOWN_TYPOGRAPHY_BY_DENSITY: Record<MarkdownDensity, MarkdownTypographyTokens> = {
  compact: {
    paragraph: `${SHARED_INLINE_TEXT} my-0 leading-5`,
    block: SHARED_INLINE_TEXT,
    list: 'm-0 pl-3.5 leading-5',
    inlineText: `${SHARED_INLINE_TEXT} leading-5`,
    listItem: `${SHARED_INLINE_TEXT} my-0 leading-5`,
  },
  relaxed: {
    paragraph: `${SHARED_INLINE_TEXT} mb-2 mt-0 leading-[1.55]`,
    block: SHARED_INLINE_TEXT,
    list: 'm-0 mb-2 mt-[0.35rem] pl-4 leading-[1.55]',
    inlineText: `${SHARED_INLINE_TEXT} leading-[1.55]`,
    listItem: `${SHARED_INLINE_TEXT} mb-1 mt-0 leading-[1.55]`,
  },
};

export const getIdeaCardMarkdownTypography = (
  density: MarkdownDensity = 'compact'
): MarkdownTypographyTokens => MARKDOWN_TYPOGRAPHY_BY_DENSITY[density];
